import { ProgressBar } from 'primereact/progressbar';
import { FC } from 'react';
import { computeResetPercent } from '../../businessLogicService/diagnosticReset';

interface Props {
  total: number;
  completed: number;
  failed: number;
}

export const DiagnosticResetProgress: FC<Props> = ({ total, completed, failed }) => {
  const processed = completed + failed;
  const percent = computeResetPercent(completed, failed, total);

  return (
    <div className="text-center py-2">
      <h3 className="font-semibold mb-4">Resetting diagnostics…</h3>
      <ProgressBar
        value={percent}
        className="mb-3"
        pt={{
          value: { style: { background: 'var(--primary-color)', transition: 'none', color: 'var(--primary-color)' } },
        }}
      />
      <p className="m-0 text-color-secondary">
        {processed} of {total} {total === 1 ? 'student' : 'students'}
      </p>
    </div>
  );
};
